export default __webpack_public_path__ + "static/assets/870639529fea101bd7770c4128b69c31.png";